"use client";

import { create } from "zustand";
import type { ConsentPreferencesT, ConsentStateT } from "@/app/types/consent";

type ConsentStoreT = {
  consent: ConsentStateT | null;
  isBannerOpen: boolean;
  isCustomizeOpen: boolean;
  setConsent: (consent: ConsentStateT) => void;
  setBannerOpen: (open: boolean) => void;
  setCustomizeOpen: (open: boolean) => void;
  mergePreferences: (update: Partial<ConsentPreferencesT>) => void;
};

export const useConsentStore = create<ConsentStoreT>((set, get) => ({
  consent: null,
  isBannerOpen: false,
  isCustomizeOpen: false,
  setConsent: (consent) => set({ consent }),
  setBannerOpen: (open) => set({ isBannerOpen: open }),
  setCustomizeOpen: (open) => set({ isCustomizeOpen: open }),
  mergePreferences: (update) => {
    const current = get().consent;
    if (!current) return;
    set({
      consent: {
        ...current,
        preferences: { ...current.preferences, ...update, necessary: true },
      },
    });
  },
}));
